import { memo, useMemo } from 'react';

import { Typography } from '@mui/material';

import { MenuModulesItem } from 'components/header/menu-modules/MenuModulesItem';
import { MenuNode } from 'components/header/menu-modules/types';

type MenuModulesSearchResults = {
    query: string;
    flatNodes: MenuNode[];
    onClose(): void;
};

/**
 * Exibe resultados parciais da busca por módulos.
 * Caso não encontre nenhum módulo, exibe uma mensagem de "nenhum módulo encontrado".
 */
export const MenuModulesSearchResults = memo(function MenuModulesSearchResults({ query, flatNodes, onClose }: MenuModulesSearchResults) {
    const filteredNodes = useMemo(() => {
        const q = query.trim().toLowerCase();

        return flatNodes.filter((n) => n.title.toLowerCase().includes(q) || (n.breadcrumb && n.breadcrumb.toLowerCase().includes(q)));
    }, [query, flatNodes]);

    if (!filteredNodes.length)
        return (
            <Typography sx={{ height: 36, lineHeight: '36px', color: 'text.secondary', fontSize: '14px', textAlign: 'center' }}>
                Nenhum módulo encontrado
            </Typography>
        );

    return (
        <>
            {filteredNodes.map((node) => (
                <MenuModulesItem key={node.path} node={node} onClose={onClose} />
            ))}
        </>
    );
});
